import {
  CONSULTATION_TYPE_STORAGE_KEY,
  DOCTOR_CONSULTATION_TYPES,
} from "../constants/consultationTypes";

// Doctor verification documents, as the upload (media) API names them, plus
// the enum names some screens still use.
export const DOCTOR_DOCUMENT_TYPES = Object.freeze({
  MEDICAL_LICENSE: "medical-licenses",
  DEGREE_CERTIFICATE: "degree-certificates",
});
const DEGREE_CERTIFICATE_TYPES = [
  DOCTOR_DOCUMENT_TYPES.DEGREE_CERTIFICATE,
  "DEGREE_CERTIFICATE",
];

/**
 * The degree certificate is optional for home-visit-only doctors; every other
 * doctor (online, or online + home visit) must upload it. Defaults to the
 * consultation type stored at login.
 */
export const isDegreeCertificateOptional = (
  consultationType = sessionStorage.getItem(CONSULTATION_TYPE_STORAGE_KEY),
) =>
  String(consultationType || "").toLowerCase() ===
  DOCTOR_CONSULTATION_TYPES.HOME;

/** True when this doctor may leave `docType` out of their verification documents. */
export const isDoctorDocumentOptional = (docType, consultationType) =>
  DEGREE_CERTIFICATE_TYPES.includes(docType) &&
  isDegreeCertificateOptional(consultationType);
